import { type HttpClient } from '../useHttpClient';

export const postInviteToChannel =
  (httpClient: HttpClient) => async (channelUrl: string, userIds: string[]) => {
    const numericUserIds = userIds.map((id) => Number(id));

    await httpClient.api(`/sendbird/channels/${channelUrl}/invite`, {
      method: 'POST',
      body: JSON.stringify({ userIds: numericUserIds }),
    });
  };
